// constants/fieldOrders.js

export const DRIVETRAIN_ORDER = [
  "ZEV-BEV",
  "Battery-electric",
  "ZEV-FCV",
  "Fuel cell",
  "Natural Gas",
  "HV",
  "Hybrid",
  "ePTO",
  "No data", // keep unknowns/fallbacks last
]

// O(1) lookup instead of indexOf() (which is O(n)) every comparison
const rank = new Map(DRIVETRAIN_ORDER.map((val, i) => [val, i]))

// Anything not in the list (new/unexpected values) sorts after known values,
// but before "No data" — this keeps a genuinely new category visible
// rather than silently invisible at the very end.
const UNKNOWN_RANK = DRIVETRAIN_ORDER.length - 1

export function drivetrainRank(value) {
  return rank.has(value) ? rank.get(value) : UNKNOWN_RANK
}

export function compareDrivetrain(a, b) {
  return drivetrainRank(a) - drivetrainRank(b)
}